module.exports = __webpack_public_path__ + "img/50d.c194a3c8.svg";